import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { currentAssessmentState } from "../data/atoms";
import { TestType } from "../models/Enums";
import { PatientVM } from "../models/PatientVM";
import {
  AFScore,
  BalloonPopperScore,
  Reports,
  VeggieSlicerScore,
} from "../models/reports";
interface Props {
  patientDetails: PatientVM;
  assessmentSummary: Reports;
}
const PatientSummaryInfo: React.FC<Props> = ({
  patientDetails,
  assessmentSummary,
}) => {
  const [score, setScore] = useState<AFScore>(new AFScore());
  const [balloonScore, setBalloonScore] = useState<BalloonPopperScore>(
    new BalloonPopperScore(),
  );
  const [veggieScore, setVeggieScore] = useState<VeggieSlicerScore>(
    new VeggieSlicerScore(),
  );
  console.log("PatientSummaryInfo assessmentSummary: ", assessmentSummary);
  const currentAssessment = useRecoilValue(currentAssessmentState);
  console.log(
    "PatientSummaryInfo assessmentType: ",
    currentAssessment?.assessmentType,
  );
  const [isTraining, setIsTraining] = useState(false);
  useEffect(() => {
    if (assessmentSummary && assessmentSummary !== undefined) {
      console.log("PatientSummaryInfo assessmentSummary: ", assessmentSummary);
      if (currentAssessment?.assessmentType === TestType.game_AF) {
        setScore(assessmentSummary.score as AFScore);
      } else if (currentAssessment?.assessmentType === TestType.hec_training) {
        setBalloonScore(assessmentSummary.score as BalloonPopperScore);
      } else if (
        currentAssessment?.assessmentType === TestType.veggie_samurai
      ) {
        setVeggieScore(assessmentSummary.score as VeggieSlicerScore);
      }
      const trainingIds = [21, 50, 51, 41];
      const isTraining = trainingIds.includes(
        currentAssessment?.assessmentType ?? -1,
      );
      setIsTraining(isTraining);
    }
  }, [assessmentSummary]);
  function formatAMPM(date: any) {
    var hours = date?.getHours();
    var minutes = date?.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }
  function formateDate(date: any) {
    let options: any = {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    };
    let d = new Date(date);
    return d?.toLocaleDateString("en-US", options);
  }
  function formatSeconds(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }
  return (
    <div>
      {/* <div className="main-heading visit-summary top-inner-sec">
                <h1>Full Visit Summary</h1>
            </div> */}
      <div className="report-user-data mb-0 ">
        <ul>
          <li>
            <strong>
              {patientDetails?.firstName} {patientDetails?.lastName}
            </strong>
          </li>
          <li>
            {assessmentSummary &&
              assessmentSummary !== undefined &&
              assessmentSummary?.testName && (
                <li>
                  <strong>
                    {isTraining ? "Training Type" : "Assessment Type"}
                  </strong>
                  <strong>
                    {currentAssessment?.assessmentType === TestType.gait
                      ? "Gait Analysis"
                      : currentAssessment?.assessmentType ===
                          TestType.red_light_green_light
                        ? "RLGL"
                        : currentAssessment?.assessmentType === TestType.tug
                          ? "TUG"
                          : currentAssessment?.assessmentType === TestType.reach
                            ? "Functional Reach"
                            : currentAssessment?.assessmentType ===
                                TestType.ctsib
                              ? "mCTSIB"
                              : assessmentSummary?.testName}
                  </strong>
                </li>
              )}
          </li>
          <li>
            <span>{formateDate(new Date(assessmentSummary?.time))}</span>{" "}
            <span>{formatAMPM(new Date(assessmentSummary?.time))}</span>
          </li>

          <li>
            {/* <span>{assessmentSummary && assessmentSummary.date}</span> <span>{assessmentSummary && assessmentSummary.time}</span> */}
          </li>
          {assessmentSummary &&
            assessmentSummary !== undefined &&
            assessmentSummary?.therapistFirstname &&
            assessmentSummary?.therapistLastName && (
              <li>
                <span>Performed by</span>{" "}
                <span>
                  Dr. {assessmentSummary?.therapistFirstname}{" "}
                  {assessmentSummary?.therapistLastName}
                </span>
              </li>
            )}
        </ul>
      </div>
      {currentAssessment?.assessmentType === TestType.game_AF &&
        score &&
        score.difficulty && (
          <div className="report-user-data mb-0 ">
            <ul>
              <li>
                <span>Movement Mode</span>
                <strong>
                  {score.difficulty?.movementType &&
                  score.difficulty?.movementType != "undefined" &&
                  score.difficulty?.movementType != null
                    ? score.difficulty?.movementType.toLowerCase() === "move"
                      ? "Lateral Step"
                      : score.difficulty?.movementType
                          .toLowerCase()
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase())
                    : "-"}
                </strong>
              </li>
              <li>
                <span>Difficulty</span>{" "}
                <strong>
                  {score.difficulty?.movementDifficulty &&
                  score.difficulty?.movementDifficulty != "undefined" &&
                  score.difficulty?.movementDifficulty != null
                    ? score.difficulty.movementDifficulty.charAt(0) +
                      score.difficulty.movementDifficulty.slice(1).toLowerCase()
                    : "-"}
                </strong>
              </li>
              <li>
                <span>Session Time</span>{" "}
                <strong>
                  {score.difficulty?.gameTime && score.difficulty.gameTime > 0
                    ? formatSeconds(score.difficulty.gameTime)
                    : score.infiniteModeTimeLasted
                      ? score.infiniteModeTimeLasted > 0
                        ? formatSeconds(score.infiniteModeTimeLasted)
                        : "-"
                      : "-"}
                </strong>
              </li>
              <li>
                <span>Played Seated</span>{" "}
                <strong>
                  {score.user1PlayedSeated === "True" ? "Yes" : "No"}
                </strong>
              </li>
            </ul>
          </div>
        )}
      {currentAssessment?.assessmentType === TestType.hec_training &&
        balloonScore &&
        balloonScore.settings && (
          <div className="report-user-data mb-0 ">
            <ul>
              <li>
                <span>Score</span>
                <strong>
                  {!isNaN(balloonScore.score) ? balloonScore.score : "-"}
                </strong>
              </li>
              <li>
                <span>Total Balloons Hit</span>{" "}
                <strong>
                  {!isNaN(balloonScore.totalBalloonsHit)
                    ? balloonScore.totalBalloonsHit
                    : "-"}
                </strong>
              </li>
              <li>
                <span>Total Missed</span>{" "}
                <strong>
                  {!isNaN(balloonScore.totalBalloonsMissed)
                    ? balloonScore.totalBalloonsMissed
                    : "-"}
                </strong>
              </li>
              <li>
                <span>Duration (s)</span>{" "}
                <strong>
                  {!isNaN(balloonScore.settings.time)
                    ? balloonScore.settings.time
                    : "-"}
                </strong>
              </li>
              <li>
                <span>Reach Mode</span>{" "}
                <strong>
                  {balloonScore.settings.reachDirection &&
                  balloonScore.settings.reachDirection != "undefined" &&
                  balloonScore.settings.reachDirection !== null
                    ? balloonScore.settings.reachDirection
                    : "-"}
                </strong>
              </li>
              <li>
                <span>Arm Mode</span>{" "}
                <strong>
                  {balloonScore.settings.armMode &&
                  balloonScore.settings.armMode != "undefined" &&
                  balloonScore.settings.armMode !== null
                    ? balloonScore.settings.armMode
                    : "-"}
                </strong>
              </li>
              <li>
                <span>Standing/Seated</span>{" "}
                <strong>
                  {balloonScore.user1PlayedSeated ? "Seated" : "Standing"}
                </strong>
              </li>
            </ul>
          </div>
        )}
      {currentAssessment?.assessmentType === TestType.veggie_samurai &&
        veggieScore &&
        veggieScore.difficulty && (
          <div className="report-user-data mb-0 ">
            <ul>
              <li>
                <span>Played Seated</span>{" "}
                <strong>
                  {veggieScore.user1PlayedSeated != "undefined" &&
                  veggieScore.user1PlayedSeated != null
                    ? veggieScore.user1PlayedSeated === "True"
                      ? "Yes"
                      : "No"
                    : "-"}
                </strong>
              </li>
              <li>
                <span>Time</span>
                <strong>
                  {!isNaN(veggieScore.difficulty.time / 60)
                    ? (veggieScore.difficulty.time / 60).toFixed(1) + " min"
                    : "-"}
                </strong>
              </li>
              <li>
                <span>Hands</span>
                <strong>
                  {veggieScore.difficulty?.armMode &&
                  veggieScore.difficulty?.armMode !== "undefined" &&
                  veggieScore.difficulty?.armMode != null
                    ? veggieScore.difficulty.armMode
                        .split("_")
                        .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
                        .join(" ")
                    : "-"}
                </strong>
              </li>
              <li>
                <span>Reach Difficulty</span>
                <strong>
                  {veggieScore.difficulty?.reachDifficulty &&
                  veggieScore.difficulty?.reachDifficulty !== "undefined" &&
                  veggieScore.difficulty?.reachDifficulty != null
                    ? veggieScore.difficulty.reachDifficulty.charAt(0) +
                      veggieScore.difficulty.reachDifficulty
                        .slice(1)
                        .toLowerCase()
                    : "-"}
                </strong>
              </li>
              <li>
                <span>Gameplay Speed</span>
                <strong>
                  {veggieScore.difficulty?.vegetableMoveSpeed &&
                  veggieScore.difficulty?.vegetableMoveSpeed !== "undefined" &&
                  veggieScore.difficulty?.vegetableMoveSpeed != null
                    ? veggieScore.difficulty.vegetableMoveSpeed.charAt(0) +
                      veggieScore.difficulty.vegetableMoveSpeed
                        .slice(1)
                        .toLowerCase()
                    : "-"}
                </strong>
              </li>
            </ul>
          </div>
        )}
    </div>
  );
};

export default PatientSummaryInfo;
